import localforage from 'localforage'

// Configuración general
localforage.config({
    name: 'alexdb',
    version: 1.0,
    storeName: 'keyvaluepairs',
    description: 'Almacenamiento offline para Andy App'
})

// Función para mostrar errores al usuario
async function showStorageError(error, operation, storeName) {
    console.error(`Error en ${operation} para ${storeName}:`, error)

    let storageInfo = await navigator.storage.estimate()

    // Crear objeto de error para el store
    const errorInfo = {
        message: `No se pudo ${operation} en ${storeName}. Verifica el espacio disponible.`,
        operation: operation,
        storeName: storeName,
        timestamp: new Date().toISOString(),
        originalError: error.message || error.toString(),
        storageInfo: storageInfo
    }

    // Actualizar el store si está disponible
    if (typeof window !== 'undefined' && window.$store) {
        window.$store.dispatch('addStorageError', errorInfo)
    }
}

// Wrapper genérico para instancias de localForage con manejo de errores
function createSafeStorage(instance, storeName) {
    return {
        // Wrapper para setItem
        async setItem(key, value, callback) {
            try {
                if (value !== undefined) {
                    //log('🔍 Intentando guardar ' + typeof value + ': ', value, ' in key ', key)
                    if (typeof value === 'object') {
                        //log('🔍 Tamaño aproximado:', JSON.stringify(value).length, 'bytes')
                    } else {
                        //log('🔍 Tamaño aproximado:', value.length, 'bytes')
                    }
                    const result = await instance.setItem(key, value)
                    if (callback) {
                        callback(result)
                    }
                    return result
                }
                return null
            } catch (error) {
                showStorageError(error, 'guardar', storeName)
                throw error // Re-lanzar el error para que el código que lo llama pueda manejarlo
            }
        },

        // Wrapper para getItem
        async getItem(key, callback) {
            try {
                const result = await instance.getItem(key)
                if (callback) {
                    callback(result)
                }
                return result
            } catch (error) {
                showStorageError(error, 'obtener', storeName)
                throw error
            }
        },

        // Wrapper para removeItem
        async removeItem(key, callback) {
            try {
                const result = await instance.removeItem(key)
                if (callback) {
                    callback(result)
                }
                return result
            } catch (error) {
                showStorageError(error, 'eliminar', storeName)
                throw error
            }
        },

        // Wrapper para clear
        async clear(callback) {
            try {
                const result = await instance.clear()
                if (callback) {
                    callback(result)
                }
                return result
            } catch (error) {
                showStorageError(error, 'limpiar', storeName)
                throw error
            }
        },

        // Wrapper para keys
        async keys(callback) {
            try {
                const result = await instance.keys()
                if (callback) {
                    callback(result)
                }
                return result
            } catch (error) {
                showStorageError(error, 'obtener claves', storeName)
                throw error
            }
        },

        // Wrapper para iterate
        async iterate(iteratorCallback, callback) {
            try {
                const result = await instance.iterate(iteratorCallback)
                if (callback) {
                    callback(result)
                }
                return result
            } catch (error) {
                showStorageError(error, 'iterar', storeName)
                throw error
            }
        },

        // Exponer la instancia original por si necesitas acceso directo
        get original() {
            return instance
        },

        async length(callback) {
            try {
                const result = await instance.length()
                if (callback) {
                    callback(result)
                }
                return result
            } catch (error) {
                showStorageError(error, 'obtener longitud', storeName)
                throw error
            }
        }
    }
}

// Crear instancias originales
const db_login_instance = localforage.createInstance({ name: 'alexdb', storeName: 'login' })
const db_updates_instance = localforage.createInstance({ name: 'alexdb', storeName: 'updates' })

const db_tasks_instance = localforage.createInstance({
    name: 'alexdb',
    storeName: 'tasks'
})
const db_tasks_queue_instance = localforage.createInstance({
    name: 'alexdb',
    storeName: 'tasks_queue'
})

const db_audits_instance = localforage.createInstance({
    name: 'alexdb',
    storeName: 'audits'
})
const db_audits_queue_instance = localforage.createInstance({
    name: 'alexdb',
    storeName: 'audits_queue'
})

const db_registers_queue_instance = localforage.createInstance({
    name: 'alexdb',
    storeName: 'registers_queue'
})

const db_issues_queue_instance = localforage.createInstance({
    name: 'alexdb',
    storeName: 'issues_queue'
})

const db_templates_instance = localforage.createInstance({
    name: 'alexdb',
    storeName: 'templates'
})

const db_registers_instance = localforage.createInstance({
    name: 'alexdb',
    storeName: 'registers'
})

const db_registers_schemas_instance = localforage.createInstance({
    name: 'alexdb',
    storeName: 'registers_schemas'
})

const db_issues_instance = localforage.createInstance({
    name: 'alexdb',
    storeName: 'issues'
})

const db_timers_instance = localforage.createInstance({
    name: 'alexdb',
    storeName: 'timers'
})

const db_checks_to_sync_instance = localforage.createInstance({
    name: 'alexdb',
    storeName: 'checks_to_sync'
})

const db_screenlock_instance = localforage.createInstance({
    name: 'alexdb',
    storeName: 'screenlock'
})

const db_legal_conditions_instance = localforage.createInstance({ name: 'alexdb', storeName: 'legal_conditions' })
const dbEmployeeLoginLogs_instance = localforage.createInstance({ name: 'alexdb', storeName: 'employee_login_logs' })
const db_timezones_instance = localforage.createInstance({ name: 'alexdb', storeName: 'timezones' })
const db_languages_instance = localforage.createInstance({ name: 'alexdb', storeName: 'languages' })
const db_employees_instance = localforage.createInstance({ name: 'alexdb', storeName: 'employee' })
const db_roles_instance = localforage.createInstance({ name: 'alexdb', storeName: 'roles' })
const db_categories_instance = localforage.createInstance({ name: 'alexdb', storeName: 'product_categories' })
const db_products_instance = localforage.createInstance({ name: 'alexdb', storeName: 'products' })
const db_collections_instance = localforage.createInstance({ name: 'alexdb', storeName: 'product_collections' })
const db_printlogs_instance = localforage.createInstance({ name: 'alexdb', storeName: 'product_printlogs' })
const db_error_logs_instance = localforage.createInstance({ name: 'alexdb', storeName: 'product_print_error_logs' })
const db_printlogs_android_instance = localforage.createInstance({ name: 'alexdb', storeName: 'product_printlogs_android' })
const db_library_categories_instance = localforage.createInstance({
    name: 'alexdb',
    storeName: 'library_categories'
})
const db_sections_instance = localforage.createInstance({
    name: 'alexdb',
    storeName: 'library_sections'
})
const db_files_instance = localforage.createInstance({
    name: 'alexdb',
    storeName: 'library_files'
})
const db_highlight_files_instance = localforage.createInstance({
    name: 'alexdb',
    storeName: 'library_highlight_files'
})
const db_logbook_instance = localforage.createInstance({ name: 'alexdb', storeName: 'logbook' })
const db_issues_templates_instance = localforage.createInstance({ name: 'alexdb', storeName: 'issues_templates' })
const db_locations_instance = localforage.createInstance({ name: 'alexdb', storeName: 'locations' })
const db_registers_items_instance = localforage.createInstance({ name: 'alexdb', storeName: 'registers_items' })
const db_audits_items_instance = localforage.createInstance({ name: 'alexdb', storeName: 'audits_items' })
const db_issues_items_instance = localforage.createInstance({ name: 'alexdb', storeName: 'issues_items' })
const db_locations_auditor_instance = localforage.createInstance({ name: 'alexdb', storeName: 'db_locations_auditor' })
const db_notification_instance = localforage.createInstance({ name: 'alexdb', storeName: 'notification' })
const db_event_instance = localforage.createInstance({ name: 'alexdb', storeName: 'event' })
const db_timerproducts_instance = localforage.createInstance({ name: 'alexdb', storeName: 'timerproducts' })
const db_tpcategories_instance = localforage.createInstance({ name: 'alexdb', storeName: 'tp_categories' })
const db_tpstates_instance = localforage.createInstance({ name: 'alexdb', storeName: 'tp_states' })
const db_timerlogs_instance = localforage.createInstance({ name: 'alexdb', storeName: 'tp_timerlogs' })
const db_timer_groups_instance = localforage.createInstance({ name: 'alexdb', storeName: 'timer_groups' })
const db_product_categories_instance = localforage.createInstance({ name: 'alexdb', storeName: 'product_categories' })
const db_action_plans_instance = localforage.createInstance({ name: 'alexdb', storeName: 'action_plans' })
const db_action_plans_queue_instance = localforage.createInstance({ name: 'alexdb', storeName: 'action_plans_queue' })

// Exportar instancias con manejo de errores (manteniendo nombres originales)
export const db_login = createSafeStorage(db_login_instance, 'login')
export const db_updates = createSafeStorage(db_updates_instance, 'updates')
export const db_tasks = createSafeStorage(db_tasks_instance, 'tasks')
export const db_tasks_queue = createSafeStorage(db_tasks_queue_instance, 'tasks_queue')
export const db_audits = createSafeStorage(db_audits_instance, 'audits')
export const db_audits_queue = createSafeStorage(db_audits_queue_instance, 'audits_queue')
export const db_action_plans = createSafeStorage(db_action_plans_instance, 'action_plans')
export const db_action_plans_queue = createSafeStorage(db_action_plans_queue_instance, 'action_plans_queue')
export const db_registers_queue = createSafeStorage(db_registers_queue_instance, 'registers_queue')
export const db_issues_queue = createSafeStorage(db_issues_queue_instance, 'issues_queue')
export const db_templates = createSafeStorage(db_templates_instance, 'templates')
export const db_registers = createSafeStorage(db_registers_instance, 'registers')
export const db_registers_schemas = createSafeStorage(db_registers_schemas_instance, 'registers_schemas')
export const db_issues = createSafeStorage(db_issues_instance, 'issues')
export const db_timers = createSafeStorage(db_timers_instance, 'timers')
export const db_checks_to_sync = createSafeStorage(db_checks_to_sync_instance, 'checks_to_sync')
export const db_screenlock = createSafeStorage(db_screenlock_instance, 'screenlock')
export const db_legal_conditions = createSafeStorage(db_legal_conditions_instance, 'legal_conditions')
export const dbEmployeeLoginLogs = createSafeStorage(dbEmployeeLoginLogs_instance, 'employee_login_logs')
export const db_timezones = createSafeStorage(db_timezones_instance, 'timezones')
export const db_languages = createSafeStorage(db_languages_instance, 'languages')
export const db_employees = createSafeStorage(db_employees_instance, 'employee')
export const db_roles = createSafeStorage(db_roles_instance, 'roles')
export const db_categories = createSafeStorage(db_categories_instance, 'product_categories')
export const db_products = createSafeStorage(db_products_instance, 'products')
export const db_collections = createSafeStorage(db_collections_instance, 'product_collections')
export const db_printlogs = createSafeStorage(db_printlogs_instance, 'product_printlogs')
export const db_error_logs = createSafeStorage(db_error_logs_instance, 'product_print_error_logs')
export const db_printlogs_android = createSafeStorage(db_printlogs_android_instance, 'product_printlogs_android')
export const db_library_categories = createSafeStorage(db_library_categories_instance, 'library_categories')
export const db_sections = createSafeStorage(db_sections_instance, 'library_sections')
export const db_files = createSafeStorage(db_files_instance, 'library_files')
export const db_highlight_files = createSafeStorage(db_highlight_files_instance, 'library_highlight_files')
export const db_logbook = createSafeStorage(db_logbook_instance, 'logbook')
export const db_issues_templates = createSafeStorage(db_issues_templates_instance, 'issues_templates')
export const db_locations = createSafeStorage(db_locations_instance, 'locations')
export const db_registers_items = createSafeStorage(db_registers_items_instance, 'registers_items')
export const db_audits_items = createSafeStorage(db_audits_items_instance, 'audits_items')
export const db_issues_items = createSafeStorage(db_issues_items_instance, 'issues_items')
export const db_locations_auditor = createSafeStorage(db_locations_auditor_instance, 'db_locations_auditor')
export const db_notification = createSafeStorage(db_notification_instance, 'notification')
export const db_event = createSafeStorage(db_event_instance, 'event')
export const db_timerproducts = createSafeStorage(db_timerproducts_instance, 'timerproducts')
export const db_tpcategories = createSafeStorage(db_tpcategories_instance, 'tp_categories')
export const db_tpstates = createSafeStorage(db_tpstates_instance, 'tp_states')
export const db_timerlogs = createSafeStorage(db_timerlogs_instance, 'tp_timerlogs')
export const db_timer_groups = createSafeStorage(db_timer_groups_instance, 'timer_groups')
export const db_product_categories = createSafeStorage(db_product_categories_instance, 'product_categories')

// Función centralizada para limpiar datos
export async function cleanAllStorage() {
    console.warn('INIT - cleanAllStorage')
    try {
        const promises = [
            db_login.clear(),
            db_updates.clear(),
            db_tasks_queue.clear(),
            db_audits_queue.clear(),
            db_registers_queue.clear(),
            db_issues_queue.clear(),
            db_templates.clear(),
            db_registers.clear(),
            db_registers_schemas.clear(),
            db_issues.clear(),
            db_timers.clear(),
            db_checks_to_sync.clear(),
            db_employees.clear(),
            db_roles.clear(),
            db_screenlock.clear(),
            db_legal_conditions.clear(),
            dbEmployeeLoginLogs.clear(),
            db_product_categories.clear(),
            db_products.clear(),
            db_collections.clear(),
            db_printlogs.clear(),
            db_error_logs.clear(),
            db_printlogs_android.clear(),
            db_library_categories.clear(),
            db_sections.clear(),
            db_files.clear(),
            db_highlight_files.clear(),
            db_logbook.clear(),
            db_issues_templates.clear(),
            /* db_locations.clear(), */ db_registers_items.clear(),
            db_audits_items.clear(),
            db_issues_items.clear(),
            db_locations_auditor.clear(),
            db_notification.clear(),
            db_event.clear(),
            db_timerproducts.clear(),
            db_tpcategories.clear(),
            db_tpstates.clear(),
            db_timerlogs.clear(),
            db_timer_groups.clear(),
            db_tasks.clear(),
            db_audits.clear(),
            db_action_plans.clear(),
            db_action_plans_queue.clear()
        ]
        await Promise.all(promises)
        console.warn('INIT - cleanAllStorage - done')
        return true
    } catch (error) {
        console.error('Error al limpiar almacenamiento:', error)
        return false
    }
}

// Función para configurar el sistema de notificaciones
export function configureStorageNotifications(notificationCallback) {
    if (typeof window !== 'undefined') {
        window.showNotification = notificationCallback
    }
}
